module.exports = __webpack_public_path__ + "img/order-box-userprofile.ffe2f660.svg";